<template name="selectCourse">
  <div class="selectCourse">
    <div class="row" @click="showCourse=!showCourse">
      <div class="new-invite-title col-9">
        {{$t('SelectCourse')}}
      </div>
      <div class="col-3">
        <i class="iconfont" :class="showCourse ? 'icon-up' : 'icon-down'"></i>
      </div>
    </div>
    <transition name="slide-fade">
      <div class="courseDetail" v-show="showCourse">
        <div>
          <div class="row">
            <div class="col-9">
              <strong>{{$t('RequireTraining')}}</strong>
            </div>
            <div class="col-3 switch">
              <input type="checkbox" name="join_course" id="join-course"
              @change="$emit('joinCourse', $event)" :checked="isJoin">
              <label for="join-course"></label>
            </div>
          </div>
          <div class="course-list">
            <div class="row" v-for="(elLesson, idx) in elLessonList" :key="idx">
              <div class="col-9">{{ elLesson.categoryName }}</div>
              <div class="col-3 switch">
              <input type="checkbox" name="join_course" :checked="elLesson.checked" :disabled="disabled"
              :value="elLesson.id" :id="`el-${elLesson.id}`" @change="$emit('courseSelect', $event)">
              <label :for="`el-${elLesson.id}`"></label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script type="text/javascript">
export default {
  name: 'selectCourse',
  props: {
    isJoin: Boolean,
    elLessonList: Array,
  },
  data() {
    return {
      showCourse: false,
    };
  },
  watch: {
    isJoin(val) {
      if (val) {
        this.showCourse = true;
      }
    },
  },
  computed: {
    disabled() {
      return !this.isJoin;
    },
  },
};
</script>

<style scoped lang="scss">
  .selectCourse {
    width: 100%;
    margin: auto;
    width: 100%;
    margin: 0 auto;
    padding: 0;
    background-color: #fff;
    border-radius: 4px;
    & > .row {
      margin: 0;
      padding: 15px 0;
      align-items: center;
      & > div:first-child {
        // font-family: HiraginoSansGB-W6;
        font-size: 14px;
        color: #4a4a4a;
      }
      .col-3 {
        text-align:right;
        line-height: 1;
        i {
          font-size: 12px;
          display: inline-block;
          transform: scale(0.75,0.75);
        }
      }
    }
    .courseDetail {
      border-top: 1px solid #f0f1f2;
      padding: 24px 0 18px;
      & > div {
        padding: 0 12px;
        & > .row {
          margin: 0 0 16px;
          div {
            // font-family: HiraginoSansGB-W6;
            font-size: 13px;
            line-height: 24px;
            padding: 0;
            vertical-align: middle;
            img {
             width: 48px;
             height: 26px;
            }
          }
          & > div:nth-of-type(2) {
            text-align: right;
          }
        }
        .course-list {
          & > .row {
            margin: 0 0 5px;
            div {
              // font-family: HiraginoSansGB-W3;
              font-size: 13px;
              line-height: 24px;
              padding: 0;
              vertical-align: middle;
              input {
                -webkit-appearance: none;
                outline: none;
                border: none;
                background: url('../assets/images/copy-14.png') no-repeat center;
                background-size: 100%;
                padding-right: 20px;
                width: 20px;
                height: 20px;
              }
            }
            & > div:nth-of-type(2) {
              text-align: right;
              padding-right: 10px;
            }
          }
        }
      }
      .switch {
        label {
          position: relative;
          width: 48px;
          height: 26px;
          &:before,
          &:after {
            content: '';
            position: absolute;
            display: block;
            transition: all ease .3s;
          }
          &:before {
            background: #dadada;
            border-radius: 13px;
            width: 48px;
            height: 26px;
            top: 0;
            right: 0;
          }
          &:after {
            background: #fff;
            border-radius: 11px;
            width: 22px;
            height: 22px;
            display: block;
            top: 2px;
            right: 24px;
          }
        }
        input {
          display: none;
          &:checked {
            & + label {
              &:before {
                background: #e42029;
              }
              &:after {
                right: 2px;
              }
            }
          }
        }
      }
      .course-list {
        .switch {
          label {
            height: 18px;
            width: 18px;
            &:before {
              border: 2px solid #dadada;
              border-radius: 9px;
              width: 18px;
              height: 18px;
              background: transparent;
              top: 0;
              right: 0;
            }
            &:after {
              background: #e42029;
              border-radius: 4px;
              width: 8px;
              height: 8px;
              display: block;
              top: 5px;
              right: 5px;
              opacity: 0;
            }
          }
        input {
          &:checked {
            & + label {
              &:before {
                background: transparent;
                border-color: #e42029;
              }
              &:after {
                right: 5px;
                opacity: 1;
              }
            }
          }
        }
        }
      }
    }
  }
</style>
